import { render } from "./iconUser.vue?vue&type=template&id=47224cc9"
import script from "./iconUser.vue?vue&type=script&lang=js"
export * from "./iconUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__